<template>
	<div class="video-mix-container">
		<div class="content-area">
			<div class="empty-state">
				<i class="el-icon-picture-outline"></i>
				<p>视频混剪功能开发中...</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'VideoMix',
	data() {
		return {}
	},
	methods: {}
}
</script>

<style scoped>
.video-mix-container {
	padding: 20px;
}

.content-area {
	background-color: #fff;
	border-radius: 8px;
	padding: 40px;
	min-height: 400px;
}

.empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 60px 0;
}

.empty-state i {
	font-size: 64px;
	color: #909399;
	margin-bottom: 20px;
}

.empty-state p {
	font-size: 16px;
	color: #909399;
	margin: 0;
}
</style>